import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import PreLamination from '../Forms/Prelamination Form 1/Prelamination_main';
import PostLamination from '../Forms/PostLamination Form 2/PostLmaination_main';

const Section1 = () => {
  const { formId } = useParams(); // Get the form ID from the route
  const navigate = useNavigate(); // Hook for navigation

  // Handler for navigating back to the forms page
  const handleBackToForms = () => {
    navigate('/inspections/forms');
  };

  return (
    <div className="max-w-7xl mx-auto p-0">
      <button
        onClick={handleBackToForms}
        className="mb-4 inline-flex items-center text-gray-700 hover:text-gray-600 font-bold text-md focus:outline-none focus:underline"
      >
        ← Back to Forms
      </button>

      {/* Section Title */}
      <h2 className="text-2xl font-semibold mb-4">Section 1</h2>

      {/* Render the appropriate form based on the formId */}
      {formId === 'form1' && <PreLamination />}
      {formId === 'form2' && <PostLamination />}
      {/* Example: {formId === 'form3' && <Form_3 />} */}
    </div>
  );
};

export default Section1;